/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// TODO: Fix eslint errors
import React from "react";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { DA_Container } from "@danishagro/shared/src/components/atoms/Container/Container.component";
import { DA_Text } from "@danishagro/shared/src/components/atoms/Text/Text.component";
import {
    DA_Title,
    DA_TitleTag,
} from "@danishagro/shared/src/components/atoms/Title/Title.component";
import { SSH_Buttons } from "../../../../components/molecules/Buttons/Buttons.component";
import { useBackgroundColor } from "../../../../hooks/useBackgroundColor/useBackgroundColor.hook";
import { usePadding } from "../../../../hooks/usePadding/usePadding.hook";
import VideoPlayerViewer from "../../../../components/organisms/VideoPlayerViewer/VideoPlayerViewer.component";
import { V1Props } from "./TextVideoV1.interface";
import { useAlignment } from "./hooks/useAlignment.hook";
import { usePosition } from "./hooks/usePosition.hook";
import { useSize } from "./hooks/useSize.hook";
// eslint-disable-next-line css-modules/no-unused-class
import S from "./TextVideoV1.module.scss";

const V1 = (props: V1Props) => {
    // Settings
    const { positionClass } = usePosition(props.position, S);
    const { backgroundColorClass, alternativeButtonTheme, hasBackgroundColor } = useBackgroundColor(
        props.backgroundColor
    );
    const { paddingClass } = usePadding(props.isCompact, hasBackgroundColor);
    const { alignmentClass } = useAlignment(props.alignment, S);
    const { sizeClass } = useSize(props.videoSize, S);

    return (
        <div
            className={cn(
                S.wrapper,
                paddingClass,
                positionClass,
                backgroundColorClass,
                alignmentClass,
                sizeClass
            )}
        >
            <DA_Container noVerticalPadding>
                <div className={S.inner}>
                    {/** Content */}
                    <div className={S.textWrapper}>
                        {/** Tagline */}
                        {props.tagline ? <span className={S.tagline}>{props.tagline}</span> : null}

                        {/** Title */}
                        {props.headline ? (
                            <div className={S.title}>
                                <DA_Title h2 tag={DA_TitleTag.H2} noMargin fullWidth>
                                    {props.headline}
                                </DA_Title>
                            </div>
                        ) : null}

                        {/** Text */}
                        {props.text ? (
                            <div className={S.text}>
                                <DA_Text html={props.text} noPadding />
                            </div>
                        ) : null}

                        {/** Buttons */}
                        {props.buttons && props.buttons.length > 0 && (
                            <div className={S.button}>
                                <SSH_Buttons
                                    buttons={props.buttons}
                                    theme={alternativeButtonTheme}
                                />
                            </div>
                        )}
                    </div>

                    {/** Video */}
                    <div className={S.videoWrapper}>
                        <VideoPlayerViewer {...props} />
                    </div>
                </div>
            </DA_Container>
        </div>
    );
};

export default V1;
